import { Button } from 'components/UI/Button/Button';
import React from 'react';

interface ContinueButtonProps {
    onClick: () => void;
    disabled?: boolean;
    isLastStep?: boolean;
}

export const ContinueButton: React.FC<ContinueButtonProps> = props => {
    return (
        <Button fullWidth onClick={props.onClick} disabled={props.disabled}>
            {props.isLastStep ? 'Submit' : 'Continue'}
        </Button>
    );
};
